class valueHelper {
  static getValue (data, field, isBadge = false) {
    if (data) {
      if (isBadge) {
        return `<span class="kt-badge kt-badge--info kt-badge--inline kt-badge--pill">${  data[field]  }</span>`
      } else {
        return data[field]
      }
    }
    return '--'
  }
  static getArrValue (data, field, isBadge = false) {
    if (data[0]) {
      if (isBadge) {
        return `<span class="kt-badge kt-badge--info kt-badge--inline kt-badge--pill">${  data[0][field]  }</span>`
      } else {
        return data[0][field]
      }
    }
  }
  static getResultType (data, resultId) {
    let result = ''
    let setColor = ''
    const resultClassColor = {
      1: 'text-primary',
      2: 'text-success',
      3: '',
      4: 'text-danger'
    }

    data.forEach((value, key) => {
      if (resultId === value.id) {
        setColor = resultClassColor[value.id]
        result = value.name
      }
    })

    return `<span class="${setColor}"> ${result} </span>`
  }
}

export default valueHelper
